import React from 'react';
import AgendarCita from '../components/AgendarCita/AgendarCita'

export default function AgendarCitaPage() {
  return (
    <div className="form-section">
      <p>EN SAFARIVET PUEDES RESERVAR UNA CONSULTA MÉDICA EN LÍNEA</p>
      <AgendarCita />
    </div>
  );
}